import Details from './DetailsContainer';

export default Details;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Details/index.js